export default function SingleOutlinedStar({ className }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.98157 0.844353L7.98158 0.844369L9.44184 5.18327L9.52158 5.42021L9.75896 5.49862L14.1529 6.95007L14.153 6.95009C14.359 7.01814 14.4919 7.20586 14.4916 7.41053C14.4914 7.61519 14.3581 7.80256 14.1519 7.87008L14.1519 7.87009L9.75459 9.31001L9.51703 9.3878L9.43674 9.62452L7.96652 13.9596L7.96651 13.9596C7.90012 14.1554 7.71128 14.2932 7.49221 14.2929C7.27316 14.2926 7.08464 14.1543 7.01869 13.9583L7.01868 13.9583L5.55843 9.61943L5.47869 9.3825L5.24131 9.30408L0.847285 7.85263L0.84727 7.85263C0.641218 7.78457 0.50837 7.59684 0.508605 7.39218C0.50884 7.18752 0.642118 7.00014 0.848326 6.93262L0.848342 6.93262L5.24568 5.4927L5.48324 5.41491L5.56353 5.17818L7.03374 0.843124L7.03374 0.84312C7.10014 0.647323 7.28899 0.509542 7.50803 0.509829C7.72709 0.510116 7.91564 0.64841 7.98157 0.844353Z"
        stroke="#FACA20"
      />
    </svg>
  );
}
